import { getRegisterFunction } from '../../utils/register.js';
import { OneUxTabsIndicator } from './OneUxTabsIndicator.js';
export const register = getRegisterFunction(OneUxTabsIndicator);
declare global {
  interface HTMLElementTagNameMap {
    "tabs-indicator-f35ade8f0e0677f92ee6ef2fc7ee48c9": OneUxTabsIndicator;
  }
}